<template>
  <div class="uk-background-muted_">
    <div class="uk-grid uk-grid-collapse" data-uk-grid>
      <!--левая стороная таблицы-->
      <div class="uk-width-auto">
        <div class="uk-width-medium">
          <div
              class="uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle uk-child-width-1-1 uk-grid-stack tm-grid-left-side"
              data-uk-grid>
            <!--#-->
            <div class="uk-text-bold tm-admin-report-head">
              <div class="uk-padding-xsmall uk-text-center" style="opacity: 0;">#</div>
            </div>
            <template v-for="(item, index) in rows[tab]">
              <div :key="index">
                <div v-if="item.divider">
                  <hr class="tm-hr uk-margin-remove"/>
                </div>
                <div class="uk-padding-xsmall" :class="item.class"
                     :data-uk-tooltip="'title: ' + item.tooltip + '; delay: 500'">
                  {{item.name}}
                  <span v-if="item.beta" class="uk-label tm-label" style="position: absolute; top: 0; right: 0;">Beta</span>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <!--правая стороная таблицы-->
      <div class="uk-width-expand">
        <div class="uk-position-relative" data-uk-slider="finite: true">
          <div class="uk-padding text-center text-danger" v-if="!reports.length && !loading">
            Нет данных
          </div>
          <ul class="uk-slider-items uk-grid uk-grid-collapse uk-flex-middle uk-child-width-1-6 uk-grid-stack tm-grid-right-side">
            <li  v-for="(report,index) in reports"  :key='index.id' >
              <div class="uk-grid uk-grid-collapse uk-grid-divider uk-flex-middle uk-child-width-1-1 uk-grid-stack uk-text-center uk-animation-slide-right-small" data-uk-grid>
                <!--номер недели/месяца-->
                <div class="uk-text-bold tm-admin-report-head">
                  <div class="uk-padding-xsmall" :data-uk-tooltip="'title: ' + report.formatted_period + ' ; delay: 100'">
                    {{report.period}}
                  </div>
                </div>
                <!--Всего заказов (шт)-->
                <div>
                  <div class="uk-padding-xsmall">
                    {{report.numbers_orders}}
                  </div>
                  <div class="uk-dropdown tm-dropdown tm-admin-report-dropdown uk-text-left"
                       data-uk-dropdown="animation: uk-animation-slide-top-small; pos: top; delay-hide: 100; delay-show: 0; offset: 5">
                    <div v-html="getTooltipForData('numbers_orders',report)"></div>
                  </div>
                </div>
                <!--Средняя задержка выполнения заказов (мин)-->
                <div>
                  <div class="uk-padding-xsmall">
                    {{report['awe_delay'] }}
                  </div>
                  <div class="uk-dropdown tm-dropdown tm-admin-report-dropdown uk-text-left"
                       data-uk-dropdown="animation: uk-animation-slide-top-small; pos: top; delay-hide: 100; delay-show: 0; offset: 5">
                    <div>
                      Средняя задержка выполнения заказа составляет <b>{{report['awe_delay'] }} мин</b>. Отличным результатом считается результат до 5 мин, Хорошим до 10 минут, Средним до 15 минут, Слабым до 20 минут, Плохим более 20 минут.
                    </div>
                  </div>
                </div>
                <!--Самая большая задержка выполнения заказов-->
                <div>
                  <div class="uk-padding-xsmall">
                    {{report['biggest_delay_order'] }}
                  </div>
                  <div class="uk-dropdown tm-dropdown tm-admin-report-dropdown uk-text-left"
                       data-uk-dropdown="animation: uk-animation-slide-top-small; pos: top; delay-hide: 100; delay-show: 0; offset: 5">
                    <div>
                      Самая большая задержка выполнения заказа выполнялся <b>{{ report['biggest_delay_order'] }} мин</b>. Отличным результатом считается результат до 60 мин, Хорошим до 110 минут, Средним до 160 минут, Слабым до 210 минут, Плохим более 210 минут. (1 заказ с самой большой задержкой выполнения в день в расчете не учитывается).
                    </div>
                  </div>
                </div>
                <!-- Количество негативных отзывов (%)-->
                <div>
                  <div class="uk-padding-xsmall">
                    {{report.awe_quaility}}
                  </div>
                  <div class="uk-dropdown tm-dropdown tm-admin-report-dropdown uk-text-left"
                       style="width: 350px;"
                       data-uk-dropdown="animation: uk-animation-slide-top-small; pos: top; delay-hide: 100; delay-show: 0; offset: 5">
                    <div>
                      Количество негативных отзывов составило <b>{{report.awe_quaility}}%</b>. Отличным результатом считается результат менее 2%, Хорошим менее 3%, Средним менее 4%, Слабым менее 5%, Очень слабым менее 6%, Плохим менее 9%, Очень плохим менее 12%, Катастрофическим более 12%.
                    </div>
                  </div>
                </div>
                <!--5* (шт)-->
                <div>
                  <div class="uk-padding-xsmall">
                    {{report['5_star'] }}
                  </div>
                  <div class="uk-dropdown tm-dropdown tm-admin-report-dropdown uk-text-left"
                       data-uk-dropdown="animation: uk-animation-slide-top-small; pos: top; delay-hide: 100; delay-show: 0; offset: 5">
                    <div>
                      Количество оценок 5* за период составил <b>{{report['5_star'] }}</b>
                    </div>
                  </div>
                </div>
                <!--4* (шт)-->
                <div>
                  <div class="uk-padding-xsmall">
                    {{report['4_star'] }}
                  </div>
                  <div class="uk-dropdown tm-dropdown tm-admin-report-dropdown uk-text-left"
                       data-uk-dropdown="animation: uk-animation-slide-top-small; pos: top; delay-hide: 100; delay-show: 0; offset: 5">
                    <div>
                      Количество оценок 4* за период составил <b>{{report['4_star'] }}</b>
                    </div>
                  </div>
                </div>
                <!--3* (шт)-->
                <div>
                  <div class="uk-padding-xsmall">
                    {{report['3_star'] }}
                  </div>
                  <div class="uk-dropdown tm-dropdown tm-admin-report-dropdown uk-text-left"
                       data-uk-dropdown="animation: uk-animation-slide-top-small; pos: top; delay-hide: 100; delay-show: 0; offset: 5">
                    <div>
                      Количество оценок 3* за период составил <b>{{report['3_star'] }}</b>
                    </div>
                  </div>
                </div>
                <!--2* (шт)-->
                <div>
                  <div class="uk-padding-xsmall">
                    {{report['2_star'] }}
                  </div>
                  <div class="uk-dropdown tm-dropdown tm-admin-report-dropdown uk-text-left"
                       data-uk-dropdown="animation: uk-animation-slide-top-small; pos: top; delay-hide: 100; delay-show: 0; offset: 5">
                    <div>
                      Количество оценок 2* за период составил <b>{{report['2_star'] }}</b>
                    </div>
                  </div>
                </div>
                <!--1* (шт)-->
                <div>
                  <div class="uk-padding-xsmall">
                    {{report['1_star'] }}
                  </div>
                  <div class="uk-dropdown tm-dropdown tm-admin-report-dropdown uk-text-left"
                       data-uk-dropdown="animation: uk-animation-slide-top-small; pos: top; delay-hide: 100; delay-show: 0; offset: 5">
                    <div>
                      Количество оценок 1* за период составил <b>{{report['1_star'] }}</b>
                    </div>
                  </div>
                </div>

                <template v-if="tab === 'weeks'">
                <!--Перелимит простоя (дни)-->
                <div>
                  <div class="uk-padding-xsmall">
                    {{report.overtime_waiting_minutes_sum}}
                  </div>
                  <div v-if="report.overtime_waiting_minutes"
                       class="uk-dropdown tm-dropdown tm-admin-report-dropdown"
                       data-uk-dropdown="animation: uk-animation-slide-top-small; pos: top; delay-hide: 100; delay-show: 0; offset: 5">
                    <!--Перелимит простоя в разрезе недели-->
                    <div class="uk-grid uk-grid-collapse uk-flex-middle uk-child-width-1-1 tm-text-small uk-grid-divider" data-uk-grid>
                      <div v-for="(value, day) in JSON.parse(report.overtime_waiting_minutes)" :key="day">
                        <div class="uk-padding-xxsmall">
                          <div class="uk-grid uk-grid-small uk-child-width-1-2 uk-flex-middle" data-uk-grid>
                            <div class="uk-text-left">
                              {{ day }}
                            </div>
                            <div class="uk-text-right">
                              {{ value.minutes }} мин <div v-if="value.overtime === 1">перелимит</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--разделитель-->
                <div><hr class="tm-hr uk-margin-remove"/></div>
                <!--Премия за скорость (грн)-->
                <div>
                  <div class="uk-padding-xsmall uk-text-bold">
                    {{report.speed_bonus}}
                  </div>
                  <div class="uk-dropdown tm-dropdown tm-admin-report-dropdown uk-text-left"
                       style="width: 350px;"
                       data-uk-dropdown="animation: uk-animation-slide-top-small; pos: top; delay-hide: 100; delay-show: 0; offset: 5">
                    <div v-if="report.period >= 18">
                      Премия за выбранную неделю составила <b>{{report.speed_bonus}}грн</b>. Вот формула по которой это рассчитывалось: (Премия составляет 3000грн, если оба условия соблюдаются: Средняя задержка выполнения заказа менее 5 минут и самая большая задержка менее 60 минут.<br>
                      Премия составляет 1500грн, если оба условия соблюдаются: Средняя задержка выполнения заказа менее 10 минут и самая большая задержка менее 110 минут.<br>
                      Премия составляет 1000грн, если оба условия соблюдаются: Средняя задержка выполнения заказа менее 15 минут и самая большая задержка менее 160 минут.<br>
                      Премия составляет 500грн, если оба условия соблюдаются: Средняя задержка выполнения заказа менее 20 минут и самая большая задержка менее 210 минут.) -2.85% за каждый день перелимита простоя (Максимально возможный вычет за неделю 20%)
                    </div>
                    <div v-else>
                      Премия за выбранную неделю составила <b>{{report.speed_bonus}}грн</b>. Вот формула по которой это рассчитывалось: (Премия составляет 3000грн, если оба условия соблюдаются: Средняя скорость выполнения заказа менее 10 минут и самый медленный заказ менее 100 минут.<br>
                      Премия составляет 1500грн, если оба условия соблюдаются: Средняя скорость выполнения заказа менее 15 минут и самый медленный заказ менее 150 минут.<br>
                      Премия составляет 1000грн, если оба условия соблюдаются: Средняя скорость выполнения заказа менее 20 минут и самый медленный заказ менее 200 минут.<br>
                      Премия составляет 500грн, если оба условия соблюдаются: Средняя скорость выполнения заказа менее 25 минут и самый медленный заказ менее 250 минут.)
                      -2.85% за каждый день перелимита простоя (Максимально возможный вычет за неделю 20%)
                    </div>
                  </div>
                </div>
                <!--Премия за качество (грн)-->
                <div>
                  <div class="uk-padding-xsmall uk-text-bold">
                    {{report.quality_bonus}}
                  </div>
                  <div class="uk-dropdown tm-dropdown tm-admin-report-dropdown uk-text-left"
                       style="width: 350px;"
                       data-uk-dropdown="animation: uk-animation-slide-top-small; pos: top; delay-hide: 100; delay-show: 0; offset: 5">
                    <div v-if="report.period >= 18">
                      Премия за выбранную неделю составила <b>{{report.quality_bonus}}грн</b>. Вот формула по которой это рассчитывалось: Если средний показатель качества менее 3%, премия составляет 1400грн. Если средний показатель качества менее 3,5%, премия составляет 1200грн. Если средний показатель качества менее 4%, премия составляет 1000грн. Если средний показатель качества менее 4,5%, премия составляет 800грн. Если средний показатель качества менее 5%, премия составляет 700грн. Если средний показатель качества менее 5,5%, премия составляет 500грн. Если средний показатель качества менее 6%, премия составляет 400грн.
                    </div>
                    <div v-else>
                      Премия за выбранную неделю составила <b>{{report.quality_bonus}}грн</b>. Вот формула по которой это рассчитывалось: Если средний показатель качества менее 2%, премия составляет 1400грн. Если средний показатель качества менее 3%, премия составляет 1200грн. Если средний показатель качества менее 4%, премия составляет 1000грн. Если средний показатель качества менее 5%, премия составляет 800грн. Если средний показатель качества менее 6%, премия составляет 700грн. Если средний показатель качества менее 9%, премия составляет 500грн. Если средний показатель качества менее 12%, премия составляет 400грн.
                    </div>
                  </div>
                </div>
                </template>
              </div>
            </li>
          </ul>
          <a class="uk-icon uk-slidenav-next uk-slidenav uk-position-top-left uk-light tm-admin-report-slidenav" href data-uk-slidenav-previous data-uk-slider-item="previous"></a>
          <a class="uk-icon uk-slidenav-next uk-slidenav uk-position-top-right uk-light tm-admin-report-slidenav" href data-uk-slidenav-next data-uk-slider-item="next"></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReportTable",
  props: {
    reports: {
      //type: Object,
      required: true
    },
    tab: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      rows: {
        months: {},
        weeks: {}
      },
      tooltipHeader: null
    }
  },
  methods: {
    initRows() {
      const monthsData = {
        'numbers_orders': {name: 'Всего заказов (шт)', class: 'uk-text-truncate', tooltip:'Общее число заказов пришедших за период', beta: false },
        'awe_delay': {name: 'Средняя задержка выполнения заказов (мин)', class: 'uk-text-truncate', tooltip: 'Средняя задержка выполнения заказов за период (min).', beta: false},
        'biggest_delay_order': {name: 'Самая большая задержка выполнения заказов (мин)', class: 'uk-text-truncate', tooltip: 'Самая большая задержка выполнения заказов за период (min).', beta: false},
        'awe_quaility': {name: 'Количество негативных отзывов (%)', class: 'uk-text-truncate', tooltip: 'Число негативных оценок за период, деленное на количество заказов за период. Негативными оценками считаются 3*,2*,1*. Чем ниже этот показатель, тем лучше.', beta: false},
        '5_star': {name: '5* (шт)', class: '', tooltip: 'Число оценок 5 полученных за период. В расчет берется только одна оценка за заказ.', beta: false},
        '4_star': {name: '4* (шт)', class: '', tooltip: 'Число оценок 4 полученных за период. В расчет берется только одна оценка за заказ.', beta: false},
        '3_star': {name: '3* (шт)', class: '', tooltip: 'Число оценок 3 полученных за период. В расчет берется только одна оценка за заказ.', beta: false},
        '2_star': {name: '2* (шт)', class: '', tooltip: 'Число оценок 2 полученных за период. В расчет берется только одна оценка за заказ.', beta: false},
        '1_star': {name: '1* (шт)', class: '', tooltip: 'Число оценок 1 полученных за период. В расчет берется только одна оценка за заказ.', beta: false},
      };
      const weeksData = {
        ...monthsData,
        'overtime_waiting_minutes': {name: 'Перелимит простоя (дни)', class: '', tooltip: 'Число дней за неделю, в которых была хотя бы одна смена на которой суммарный простой превысил 20мин * число записанных ретушеров.'},
        'speed_bonus': {name: 'Премия за скорость (грн)', class: 'uk-text-bold', tooltip: 'Премия рассчитывается по результатам недели ежедневно.', divider: true},
        'quality_bonus': {name: 'Премия за качество (грн)', class: 'uk-text-bold', tooltip: 'Премия рассчитывается по результатам недели ежедневно.'},
      };

      this.rows.months = monthsData;
      this.rows.weeks = weeksData;
      this.tooltipHeader = this.tab === 'weeks' ? 'Период недели' : 'Период месяца';

    },
    getTooltipForData(type, report) {
      let text = ''
      if (type === 'numbers_orders') {
        if (this.tab === 'weeks') {
          text = 'За  ' + report.week + '-ю неделю  ' + report.year + ' года пришло <b>' + report.numbers_orders + ' заказа</b>';
        } else if (this.tab === 'months') {
          text = 'За  ' + report.month + '-й месяц  ' + report.year + ' года пришло <b>' + report.numbers_orders + ' заказа</b>';
        }
      }
      return text;
    }
  },
  async mounted() {
    this.initRows();
  },
}
</script>

<style>
  .tm-admin-report-dropdown {
    width:100px;
    background-color: #fff;
    padding: 0;
  }
  .tm-admin-report-head {
    background-color: rgb(76, 175, 80);
    color: rgb(255, 255, 255);
  }
  .tm-grid-right-side > * .uk-grid > div {
    transition: .1s ease-in-out;
  }
  .tm-grid-right-side > *:nth-child(odd) > .uk-grid > div:not(.tm-admin-report-head) {
    background-color: rgb(0 0 0 / 3%);
  }
  .tm-grid-right-side > *:nth-child(odd) > .uk-grid > div.tm-admin-report-head {
    background-color: rgb(72 169 75) !important;
  }
  .tm-grid-right-side > *:hover > .uk-grid > div:not(.tm-admin-report-head) {
    background-color: rgb(0 0 0 / 5%);
  }
  .tm-grid-right-side > *:hover > .uk-grid > div.tm-admin-report-head {
    background-color: rgb(57 159 60) !important;
  }
  .uk-slidenav.tm-admin-report-slidenav {
    padding: 10px;
  }
  .tm-grid-right-side > * {
    position: relative;
  }
  .tm-grid-right-side > *:hover {
    z-index: 10;
  }
  .tm-admin-report-slidenav.uk-light:focus,
  .tm-admin-report-slidenav.uk-light:hover {
    color: rgba(255, 255, 255, 0.7) !important;
  }
  .tm-form-small:not(textarea):not([multiple]):not([size]) {
    padding-right: 25px;
    height: 30px;
  }


  .tm-admin-report-title {
    position: relative;
    font-size: 1.3rem;
    line-height: 1.4;
    margin-bottom: 30px;
  }
  .tm-admin-report-title::before {
    content: "";
    /* 1 */
    display: inline-block;
    /* 2 */
    position: relative;
    top: calc(-0.1 * 1em);
    vertical-align: middle;
    /* 3 */
    height: calc(4px + 0.7em);
    margin-right: calc(5px + 0.2em);
    border-left: calc(5px + 0.1em) solid #e5e5e5;
  }

</style>